export type Tema = "claro" | "escuro";
const CHAVE = "eop:tema";

export function temaAtual(): Tema {
  const salvo = localStorage.getItem(CHAVE);
  if (salvo === "claro" || salvo === "escuro") return salvo;
  // Defensivo de propósito: `matchMedia` não existe em toda superfície onde
  // este código roda, e uma exceção aqui derruba o shell inteiro na primeira
  // pintura. Sem preferência conhecida, RH e DP é uso diurno: claro.
  const prefereEscuro = typeof window !== "undefined"
    && typeof window.matchMedia === "function"
    && window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefereEscuro ? "escuro" : "claro";
}

/**
 * Tema alternável de verdade, ligado no dia 1.
 * O MKT construiu o claro e deixou o botão inerte; aqui RH e DP é uso diurno
 * de escritório e o claro é o padrão.
 */
export function aplicarTema(t: Tema): void {
  localStorage.setItem(CHAVE, t);
  document.documentElement.classList.toggle("dark", t === "escuro");
}

export const alternarTema = (): Tema => {
  const proximo: Tema = temaAtual() === "claro" ? "escuro" : "claro";
  aplicarTema(proximo);
  return proximo;
};
